var UitkMarkTokenSizesList = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 24, 30, 37, 38, 40, 48, 72];
var UitkMarkSize;
(function (UitkMarkSize) {
  UitkMarkSize["EXTRA_SMALL"] = "xsmall";
  UitkMarkSize["SMALL"] = "small";
  UitkMarkSize["MEDIUM"] = "medium";
  UitkMarkSize["MEDIUM_LARGE"] = "mlarge";
  UitkMarkSize["LARGE"] = "large";
})(UitkMarkSize || (UitkMarkSize = {}));
export { UitkMarkSize, UitkMarkTokenSizesList };